import { kebabCase } from 'lodash';

const svgGraphics = import.meta.glob('@/assets/icons/element-*.svg', { eager: true, query: '?raw', import: 'default' });

Object.entries(svgGraphics).forEach(([path, element]) => {
  const moduleName = kebabCase(
    path
      .split(/[\\/]/)
      .pop()
      .replace(/\.[^.]+$/, '')
      .replace('element-', '')
  );
  class SvgWebElement extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.innerHTML = element;
    }
  }
  customElements.define(moduleName, SvgWebElement);
}, {});
